import { getBuyerId } from 'dibs-cookie-jar';
import SV from 'server-vars';

import { fetchQuery_DEPRECATED as fetchQuery, graphql, Environment } from 'react-relay/legacy';

const VALID_PROGRAMS = ['BRONZE', 'SILVER', 'GOLD', 'PLATINUM'];
const query = graphql`
    query tradeRewardsLevelUpModalRule_Query($userId: String!) {
        viewer {
            user(userId: $userId) {
                tradeFirm {
                    rewards {
                        currentProgram {
                            programInfo {
                                code
                            }
                        }
                    }
                }
                activityFeed(first: 1, elementTypes: [TRADE_REWARD_PROGRAM]) {
                    edges {
                        node {
                            serviceId
                            type
                            status
                        }
                    }
                }
            }
        }
    }
`;

import { tradeRewardsLevelUpModalRule_Query as Query } from './__generated__/tradeRewardsLevelUpModalRule_Query.graphql';

async function queryIsLevelledUp(userId: string, relayEnvironment: Environment): Promise<boolean> {
    const data = await fetchQuery<Query>(relayEnvironment, query, { userId });
    const viewer = data?.viewer;
    const user = viewer?.user;
    const currentProgram = user?.tradeFirm?.rewards?.currentProgram?.programInfo?.code || '';
    const latestLevelUp = user?.activityFeed?.edges?.[0]?.node;
    return (
        VALID_PROGRAMS.includes(currentProgram) &&
        latestLevelUp?.type === 'TRADE_REWARD_PROGRAM' &&
        latestLevelUp?.status === 'ACTIVE'
    );
}

type RuleArgs = {
    relayEnvironment: Environment;
    forceNotification: boolean;
};

export function tradeRewardsLevelUpModalRule({
    relayEnvironment,
    forceNotification,
}: RuleArgs): Promise<boolean> {
    const isUserTypeTrade = SV.get('settings.isUserTypeTrade') || false;
    const userId = getBuyerId(document.cookie);
    if (!userId || !isUserTypeTrade) {
        return Promise.resolve(false);
    }

    if (forceNotification) {
        return Promise.resolve(true);
    }

    return queryIsLevelledUp(userId, relayEnvironment);
}
